// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/pages/style/register.css */

/* Общие стили для страницы */
.register-page {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: #1a0a2e; /* Очень темный фиолетовый фон */
  color: #e0e0e0; /* Светлый текст для контраста */
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; /* Современный шрифт */
  padding: 20px;
  box-sizing: border-box; /* Учитываем padding в общей ширине/высоте */
}

/* Стили для заголовка страницы */
.register-header {
  text-align: center;
  margin-bottom: 40px;
  padding-top: 30px;
}

.register-header .page-title {
  font-size: 2.8em;
  color: #9370DB; /* MediumPurple */
  text-shadow: 0 0 15px rgba(147, 112, 219, 0.6); /* Легкое свечение */
  letter-spacing: 1.5px;
}

/* Основное содержимое страницы (форма) */
.register-main-content {
  flex-grow: 1; /* Позволяет содержимому занимать доступное пространство */
  display: flex;
  justify-content: center;
  align-items: center; /* Центрирование формы по вертикали */
  padding: 20px 0;
}

/* Контейнер формы */
.register-form {
  background: #2a104e; /* Чуть светлее фон для формы */
  padding: 40px;
  border-radius: 15px; /* Более скругленные углы */
  box-shadow: 0 0 30px rgba(138, 43, 226, 0.4); /* Фиолетовое свечение вокруг формы */
  width: 100%;
  max-width: 450px; /* Ограничиваем ширину формы */
  display: flex;
  flex-direction: column;
  gap: 25px; /* Промежутки между элементами формы */
  border: 1px solid rgba(138, 43, 226, 0.3); /* Тонкая фиолетовая рамка */
}

/* Группа полей ввода (label + input) */
.form-group {
  display: flex;
  flex-direction: column;
}

.form-group label {
  font-size: 1.1em;
  margin-bottom: 8px;
  color: #B2A4D4; /* Светло-фиолетовый для меток */
  font-weight: 500;
}

.form-group input {
  padding: 14px 18px;
  border: 1px solid #5a2e8c; /* Темно-фиолетовая рамка */
  border-radius: 8px;
  background-color: #3a156e; /* Еще более темный фон для инпутов */
  color: #e0e0e0;
  font-size: 1.05em;
  outline: none; /* Убираем стандартную обводку */
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
}

.form-group input::placeholder {
  color: #9987B5; /* Светло-фиолетовый плейсхолдер */
  opacity: 0.7; /* Прозрачность */
}

.form-group input:focus {
  border-color: #8A2BE2; /* BlueViolet при фокусе */
  box-shadow: 0 0 12px rgba(138, 43, 226, 0.6); /* Свечение при фокусе */
  background-color: #4a1c8c; /* Чуть светлее при фокусе */
}

/* Кнопка регистрации */
.register-button {
  background: linear-gradient(45deg, #8A2BE2, #7B68EE); /* Градиент от BlueViolet до MediumSlateBlue */
  color: white;
  padding: 15px 25px;
  border: none;
  border-radius: 10px;
  font-size: 1.2em;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 8px 20px rgba(138, 43, 226, 0.4); /* Тень для эффекта парения */
  margin-top: 20px; /* Отступ сверху */
}

.register-button:hover {
  background: linear-gradient(45deg, #7B68EE, #8A2BE2); /* Инвертированный градиент при наведении */
  transform: translateY(-3px); /* Легкий подъем */
  box-shadow: 0 12px 25px rgba(138, 43, 226, 0.6); /* Усиленная тень */
}

.register-button:active {
  transform: translateY(0); /* Возврат при нажатии */
  box-shadow: 0 4px 10px rgba(138, 43, 226, 0.3); /* Меньшая тень при нажатии */
}

/* Сообщение об ошибке */
.error-message {
  color: #FF6347; /* Tomato - яркий красный для ошибок */
  background-color: rgba(255, 99, 71, 0.15); /* Полупрозрачный красный фон */
  border: 1px solid #FF6347;
  padding: 10px 15px;
  border-radius: 8px;
  margin-bottom: 15px;
  font-size: 0.95em;
  text-align: center;
}

/* Адаптивность для мобильных устройств */
@media (max-width: 600px) {
  .register-page {
    padding: 10px;
  }

  .register-header .page-title {
    font-size: 2em;
  }

  .register-form {
    padding: 25px;
    gap: 18px;
  }

  .form-group input,
  .register-button {
    padding: 12px 15px;
    font-size: 1em;
  }

  .form-group label {
    font-size: 1em;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/style/register.css"],"names":[],"mappings":"AAAA,iCAAiC;;AAEjC,6BAA6B;AAC7B;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB,EAAE,gCAAgC;EACrD,cAAc,EAAE,gCAAgC;EAChD,4DAA4D,EAAE,sBAAsB;EACpF,aAAa;EACb,sBAAsB,EAAE,4CAA4C;AACtE;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc,EAAE,iBAAiB;EACjC,8CAA8C,EAAE,oBAAoB;EACpE,qBAAqB;AACvB;;AAEA,yCAAyC;AACzC;EACE,YAAY,EAAE,0DAA0D;EACxE,aAAa;EACb,uBAAuB;EACvB,mBAAmB,EAAE,qCAAqC;EAC1D,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB,EAAE,+BAA+B;EACpD,aAAa;EACb,mBAAmB,EAAE,2BAA2B;EAChD,4CAA4C,EAAE,qCAAqC;EACnF,WAAW;EACX,gBAAgB,EAAE,8BAA8B;EAChD,aAAa;EACb,sBAAsB;EACtB,SAAS,EAAE,sCAAsC;EACjD,yCAAyC,EAAE,4BAA4B;AACzE;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc,EAAE,gCAAgC;EAChD,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB,EAAE,2BAA2B;EACtD,kBAAkB;EAClB,yBAAyB,EAAE,qCAAqC;EAChE,cAAc;EACd,iBAAiB;EACjB,aAAa,EAAE,gCAAgC;EAC/C,wDAAwD;AAC1D;;AAEA;EACE,cAAc,EAAE,kCAAkC;EAClD,YAAY,EAAE,iBAAiB;AACjC;;AAEA;EACE,qBAAqB,EAAE,0BAA0B;EACjD,4CAA4C,EAAE,wBAAwB;EACtE,yBAAyB,EAAE,4BAA4B;AACzD;;AAEA,uBAAuB;AACvB;EACE,oDAAoD,EAAE,8CAA8C;EACpG,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,8CAA8C,EAAE,6BAA6B;EAC7E,gBAAgB,EAAE,kBAAkB;AACtC;;AAEA;EACE,oDAAoD,EAAE,2CAA2C;EACjG,2BAA2B,EAAE,kBAAkB;EAC/C,+CAA+C,EAAE,mBAAmB;AACtE;;AAEA;EACE,wBAAwB,EAAE,wBAAwB;EAClD,8CAA8C,EAAE,6BAA6B;AAC/E;;AAEA,wBAAwB;AACxB;EACE,cAAc,EAAE,sCAAsC;EACtD,yCAAyC,EAAE,+BAA+B;EAC1E,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,yCAAyC;AACzC;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;;IAEE,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":["/* src/pages/style/register.css */\n\n/* Общие стили для страницы */\n.register-page {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  background: #1a0a2e; /* Очень темный фиолетовый фон */\n  color: #e0e0e0; /* Светлый текст для контраста */\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; /* Современный шрифт */\n  padding: 20px;\n  box-sizing: border-box; /* Учитываем padding в общей ширине/высоте */\n}\n\n/* Стили для заголовка страницы */\n.register-header {\n  text-align: center;\n  margin-bottom: 40px;\n  padding-top: 30px;\n}\n\n.register-header .page-title {\n  font-size: 2.8em;\n  color: #9370DB; /* MediumPurple */\n  text-shadow: 0 0 15px rgba(147, 112, 219, 0.6); /* Легкое свечение */\n  letter-spacing: 1.5px;\n}\n\n/* Основное содержимое страницы (форма) */\n.register-main-content {\n  flex-grow: 1; /* Позволяет содержимому занимать доступное пространство */\n  display: flex;\n  justify-content: center;\n  align-items: center; /* Центрирование формы по вертикали */\n  padding: 20px 0;\n}\n\n/* Контейнер формы */\n.register-form {\n  background: #2a104e; /* Чуть светлее фон для формы */\n  padding: 40px;\n  border-radius: 15px; /* Более скругленные углы */\n  box-shadow: 0 0 30px rgba(138, 43, 226, 0.4); /* Фиолетовое свечение вокруг формы */\n  width: 100%;\n  max-width: 450px; /* Ограничиваем ширину формы */\n  display: flex;\n  flex-direction: column;\n  gap: 25px; /* Промежутки между элементами формы */\n  border: 1px solid rgba(138, 43, 226, 0.3); /* Тонкая фиолетовая рамка */\n}\n\n/* Группа полей ввода (label + input) */\n.form-group {\n  display: flex;\n  flex-direction: column;\n}\n\n.form-group label {\n  font-size: 1.1em;\n  margin-bottom: 8px;\n  color: #B2A4D4; /* Светло-фиолетовый для меток */\n  font-weight: 500;\n}\n\n.form-group input {\n  padding: 14px 18px;\n  border: 1px solid #5a2e8c; /* Темно-фиолетовая рамка */\n  border-radius: 8px;\n  background-color: #3a156e; /* Еще более темный фон для инпутов */\n  color: #e0e0e0;\n  font-size: 1.05em;\n  outline: none; /* Убираем стандартную обводку */\n  transition: border-color 0.3s ease, box-shadow 0.3s ease;\n}\n\n.form-group input::placeholder {\n  color: #9987B5; /* Светло-фиолетовый плейсхолдер */\n  opacity: 0.7; /* Прозрачность */\n}\n\n.form-group input:focus {\n  border-color: #8A2BE2; /* BlueViolet при фокусе */\n  box-shadow: 0 0 12px rgba(138, 43, 226, 0.6); /* Свечение при фокусе */\n  background-color: #4a1c8c; /* Чуть светлее при фокусе */\n}\n\n/* Кнопка регистрации */\n.register-button {\n  background: linear-gradient(45deg, #8A2BE2, #7B68EE); /* Градиент от BlueViolet до MediumSlateBlue */\n  color: white;\n  padding: 15px 25px;\n  border: none;\n  border-radius: 10px;\n  font-size: 1.2em;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 8px 20px rgba(138, 43, 226, 0.4); /* Тень для эффекта парения */\n  margin-top: 20px; /* Отступ сверху */\n}\n\n.register-button:hover {\n  background: linear-gradient(45deg, #7B68EE, #8A2BE2); /* Инвертированный градиент при наведении */\n  transform: translateY(-3px); /* Легкий подъем */\n  box-shadow: 0 12px 25px rgba(138, 43, 226, 0.6); /* Усиленная тень */\n}\n\n.register-button:active {\n  transform: translateY(0); /* Возврат при нажатии */\n  box-shadow: 0 4px 10px rgba(138, 43, 226, 0.3); /* Меньшая тень при нажатии */\n}\n\n/* Сообщение об ошибке */\n.error-message {\n  color: #FF6347; /* Tomato - яркий красный для ошибок */\n  background-color: rgba(255, 99, 71, 0.15); /* Полупрозрачный красный фон */\n  border: 1px solid #FF6347;\n  padding: 10px 15px;\n  border-radius: 8px;\n  margin-bottom: 15px;\n  font-size: 0.95em;\n  text-align: center;\n}\n\n/* Адаптивность для мобильных устройств */\n@media (max-width: 600px) {\n  .register-page {\n    padding: 10px;\n  }\n\n  .register-header .page-title {\n    font-size: 2em;\n  }\n\n  .register-form {\n    padding: 25px;\n    gap: 18px;\n  }\n\n  .form-group input,\n  .register-button {\n    padding: 12px 15px;\n    font-size: 1em;\n  }\n\n  .form-group label {\n    font-size: 1em;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
